import Vue from 'vue';
import Vuex from 'vuex';
import actions from './modules/actions';
import auth from './modules/authentication.js';
import content from './modules/content.js';
import customContent from './modules/custom-content.js';
import products from './modules/products.js';
import user from './modules/user.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    actions,
    auth,
    content,
    customContent,
    products,
    user,
  },
});
